export default "__VITE_ASSET__10deaf7f__"